<template>
  <div class="index stick" @click="momdayPlay('init')">
    <div v-show="showNewPeople" class="new-people-wrap">
      <img
        id="newPeople"
        v-for="(img, i) of newPeopleConfig.img_list"
        :key="i"
        :src="img.img_path"
      />
      <img class="code-img" :src="newPeopleConfig.code_path" />
    </div>
    <follow @follow="followFn" :pathType="'homePage'"></follow>
    <van-sticky @scroll="scrollTopHeader" z-index="200" :offset-top="follow ? '0.49rem' : 0">
      <header
        class="header"
        ref="header"
        :class="{ headerheight: isheadertop }"
        :style="{ background: bannerbackcolor }"
      >
        <div class="header_content" :style="{ background: bannerbackcolor }">
          <span :class="{ opac: isheadertop }">可丽金，专研重组胶原抗老*</span>
          <div class="icon">
            <img
              v-if="signinShow == 1"
              @click="goSignin"
              src="/static/images/integral/signin.png"
            />
            <img v-else @click="goSignin" src="/static/images/index/signin.png" />
            <van-badge :dot="tagShow == 1 ? true : false">
              <img @click="goMessage" class="msg" src="/static/images/index/msg.png" />
            </van-badge>
          </div>
        </div>
        <div
          @click="searchClick"
          class="headsearch"
          :class="{ headsearchwidth: isheaderwidth, headsearchtop: isheadertop }"
        >
          <div class="searchicon">
            <van-icon name="search" />
          </div>
          <div class="inp">{{ defaultSearch ? '搜索“' + defaultSearch + '”' : '' }}</div>
        </div>
        <div v-if="!searchlist.length" class="hot" :class="{ opac: isheadertop }"></div>
        <ul v-else class="hot" :class="{ opac: isheadertop }">
          <li v-for="item of searchlist" @click="search(item)">
            <img :src="item.img_path" />
            {{ item.searchtext }}
          </li>
        </ul>
      </header>
    </van-sticky>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :type="'infinite'"
      @on-infinite="onInfinite"
      class="my_scroller"
      ref="my_scroller"
      :style="follow ? { 'margin-top': '0.56rem' } : {}"
    >
      <div class="banner">
        <div
          v-if="bannerlist.length"
          class="back"
          :class="{ backshow: isheadertop }"
          :style="{ background: bannerbackcolor }"
        ></div>
        <swiper
          v-if="bannerlist.length"
          id="swiperBanner"
          :options="bannerSwiper"
          style="height: 100%"
        >
          <swiper-slide v-for="(item, index) of bannerlist" :key="index">
            <img
              :src="item.img_path"
              @error="
                (event) => {
                  let img = event.srcElement
                  img.src = errorImg
                  img.onerror = null
                }
              "
            />
            <div
              :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=1'"
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
            ></div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" id="bannerSwiperPagination"></div>
      </div>
      <div class="featuredads mall_endorsement" v-if="mall_endorsement.img_path">
        <div
          style="position: relative"
          @click="bannerClick(mall_endorsement, 0, 'mall_endorsement-1')"
        >
          <img
            :src="mall_endorsement.img_path"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorImg
                img.onerror = null
              }
            "
          />
          <div
            :path="
              mall_endorsement.ad_target +
              (mall_endorsement.ad_target.indexOf('?') >= 0 ? '&' : '?') +
              'sorce=7'
            "
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (mall_endorsement.ad_type == 7 || mall_endorsement.ad_type == 8)"
          ></div>
        </div>
      </div>
      <div class="category" v-if="categorylisttd.length">
        <swiper id="categoryBanner" :options="categorySwiper" style="height: 100%">
          <swiper-slide v-for="(item, index) of categorylisttd" :key="index">
            <div
              style="position: relative"
              class="item"
              v-for="itemSon of item"
              :index="itemSon.index"
              @click="bannerClick(itemSon, itemSon.index, 'icon-' + (+itemSon.index + 1))"
            >
              <img v-lazy="itemSon.img_path" />
              <p class="f12">{{ itemSon.ad_title }}</p>
              <div
                :path="
                  itemSon.ad_target + (itemSon.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=2'
                "
                :username="'gh_5d4bb8e18b8b'"
                class="slide_cl_xcx"
                v-if="isWx && (itemSon.ad_type == 7 || itemSon.ad_type == 8)"
              ></div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="countdown" v-if="countdown.isshow > 0 && act_countdown.start_actimg">
        <img :src="countdown.isshow == 1 ? act_countdown.start_actimg : act_countdown.end_actimg" />
        <van-count-down :time="countdown.time" class="flex-js-ac" @finish="finishFn">
          <template #default="timeData">
            <div class="time flex-ac">
              <span class="colon flex-s">
                {{ timeData.days >= 10 ? timeData.days : '0' + timeData.days }}
              </span>
            </div>
            <div class="time flex-ac">
              <span class="colon flex-s">
                {{ timeData.hours >= 10 ? timeData.hours : '0' + timeData.hours }}
              </span>
            </div>
            <div class="time flex-ac">
              <span class="colon flex-s">
                {{ timeData.minutes >= 10 ? timeData.minutes : '0' + timeData.minutes }}
              </span>
            </div>
            <div class="time flex-ac">
              <span class="colon flex-s">
                {{ timeData.seconds >= 10 ? timeData.seconds : '0' + timeData.seconds }}
              </span>
            </div>
          </template>
        </van-count-down>
      </div>
      <div class="featuredads" v-if="privatesphere.length">
        <div
          style="position: relative"
          v-for="item of privatesphere"
          @click="bannerClick(item, index, 'privatesphere-' + (index + 1))"
        >
          <img
            :src="item.img_path"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorImg
                img.onerror = null
              }
            "
          />
          <div
            :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=7'"
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
          ></div>
        </div>
      </div>
      <div class="activity" v-if="activitylist.length">
        <swiper id="activityBanner" :options="activitySwiper" style="height: 100%">
          <swiper-slide ref="activityItem" v-for="(item, index) of activitylist" :key="index">
            <img
              class="main-img"
              :src="item.img_path"
              @error="
                (event) => {
                  let img = event.srcElement
                  img.src = errorImg
                  img.onerror = null
                }
              "
            />
            <div
              :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=5'"
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
            ></div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" id="activitySwiperPagination"></div>
      </div>
      <div class="featuredads" v-if="momday_video.video_url">
        <div class="video_box" style="position: relative">
          <img
            @click="momday_ismuted = !momday_ismuted"
            :src="momday_ismuted ? '/static/images/mute.png' : '/static/images/sound.png'"
            alt=""
          />
          <img
            class="momday_videoplay"
            @click.stop="momdayPlay"
            :src="
              momday_isplay
                ? '/static/images/community/video3.png'
                : '/static/images/community/video_paused.png'
            "
          />
          <video
            class="video_video"
            style="width: 100%; display: block"
            :poster="momday_video.videoposter_url"
            :style="{ width: '100%', height: momday_Height + 'rem' }"
            :muted="momday_ismuted"
            autoplay
            :controls="false"
            data-config="创客村"
            webkit-playsinline
            playsinline
            x5-playsinline
            @play="momday_isplay = 0"
            @playing="momday_isplay = 0"
            @ended="momday_isplay = 1"
            x-webkit-airplay="allow"
          >
            <source :src="momday_video.video_url" type="video/mp4" />
            <source :src="momday_video.video_url" type="video/m3u8" />
            您的浏览器不支持HTML5视频
          </video>
        </div>
      </div>
      <div class="featuredads" v-if="featuredads.length">
        <div
          style="position: relative"
          v-for="item of featuredads"
          @click="bannerClick(item, index, 'ad-' + (index + 1))"
        >
          <img
            :src="item.img_path"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorImg
                img.onerror = null
              }
            "
          />
          <div
            :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=7'"
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
          ></div>
        </div>
      </div>
      <div class="featuredads" v-if="communityad.img_path">
        <div
          style="position: relative"
          :key="index"
          @click="bannerClick(communityad, 0, 'communityad-1')"
        >
          <img :src="communityad.img_path" class="slide-image errorImg" mode="widthFix" />
        </div>
      </div>
      <!--    <div class="skinText" v-if="$store.state.skinTextHomeShow == 1 && skinShow">-->
      <!--      <skin-test :page="'home'"></skin-test>-->
      <!--    </div>-->
      <div class="videogoods" ref="videogoods" v-for="(item, index) of videogoodslist" :key="index">
        <div v-if="item.type == 2">
          <img class="title" :src="item.titleurl" />
          <div
            class="bgimg"
            :style="
              item.bgimg_url
                ? { background: `url(${item.bgimg_url}) center center / 100% 100% no-repeat` }
                : {}
            "
          >
            <div class="videogoods_tags flex-jc-ac" v-if="item.tagsList.length">
              <div
                v-for="(tagsitem, tagsindex) of item.tagsList"
                @click="videogoodsIndexFn(index, tagsindex)"
                class="f14"
                :style="{
                  background:
                    'url(' +
                    (item.videoIndex == tagsindex ? tagsitem.selectedimg : tagsitem.defaultimg) +
                    ') no-repeat left top'
                }"
              ></div>
            </div>
            <div
              class="activity"
              v-if="item.goodsList.length > 0"
              @click="bannerClick(item.goodsList[0], 0, 'rtc-' + (index + 1) + '-' + 1, item)"
            >
              <swiper
                id="videogoodsBanner"
                ref="videoSwiper"
                :options="videogoodsSwiper"
                :index="index"
                style="height: 100%"
              >
                <swiper-slide
                  ref="activityItem"
                  v-for="(goodsitem, goodsindex) of item.goodsList"
                  :key="goodsindex"
                >
                  <div
                    class="image"
                    style="width: 100%; height: 100% !important; position: relative"
                    v-if="goodsitem.type == 1 && goodsitem.videourl"
                  >
                    <div class="video zy_media">
                      <video
                        class="video_banner"
                        :class="'video_banner-' + index + '-' + goodsindex"
                        :ref="'video_banner-' + index + '-' + goodsindex"
                        :poster="goodsitem.videoimgurl"
                        loop
                        muted
                        data-config="创客村"
                        webkit-playsinline
                        playsinline
                        x5-playsinline
                        x-webkit-airplay="allow"
                      >
                        <source :src="goodsitem.videourl" type="video/mp4" />
                        <source :src="goodsitem.videourl" type="video/m3u8" />
                        您的浏览器不支持HTML5视频
                      </video>
                    </div>
                  </div>
                  <div v-else-if="goodsitem.videourl" class="image" style="position: relative">
                    <img
                      :ref="'video_banner-' + index + '-' + goodsindex"
                      :src="goodsitem.videourl"
                      @error="
                        (event) => {
                          let img = event.srcElement
                          img.src = errorImg
                          img.onerror = null
                        }
                      "
                    />
                  </div>
                </swiper-slide>
              </swiper>
              <img class="baseimg" style="width: 100%" :src="item.baseimg_url" />
            </div>
          </div>
        </div>
        <div v-else>
          <img class="title" :src="item.titleurl" />
          <div class="videogoods_tags flex-jc-ac" v-if="item.tagsList.length">
            <div
              v-for="(tagsitem, tagsindex) of item.tagsList"
              @click="videogoodsIndexFn(index, tagsindex)"
              class="f14"
              :style="{
                background:
                  'url(' +
                  (item.videoIndex == tagsindex ? tagsitem.selectedimg : tagsitem.defaultimg) +
                  ') no-repeat left top'
              }"
            ></div>
          </div>
          <van-swipe
            id="videoBanner"
            class="swiper-container"
            ref="videoSwiper"
            style="height: 100%"
            :autoplay="5000"
            :show-indicators="false"
            :initial-swipe="item.initialIndex"
            @change="videogoodschange($event, index)"
          >
            <van-swipe-item
              class="swiper-slide"
              v-for="(goodsitem, goodsindex) of item.goodsList"
              :key="goodsindex"
            >
              <div
                class="image"
                style="width: 100%; height: 100% !important"
                v-if="goodsitem.type == 1 && goodsitem.videourl"
              >
                <div class="video zy_media">
                  <video
                    class="video_banner"
                    :class="'video_banner-' + index + '-' + goodsindex"
                    :ref="'video_banner-' + index + '-' + goodsindex"
                    :poster="goodsitem.videoimgurl"
                    loop
                    muted
                    data-config="创客村"
                    webkit-playsinline
                    playsinline
                    x5-playsinline
                    x-webkit-airplay="allow"
                  >
                    <source :src="goodsitem.videourl" type="video/mp4" />
                    <source :src="goodsitem.videourl" type="video/m3u8" />
                    您的浏览器不支持HTML5视频
                  </video>
                </div>
              </div>
              <div
                v-else-if="goodsitem.videourl"
                class="image"
                @click="
                  bannerClick(
                    goodsitem,
                    goodsindex,
                    'rtc-' + (index + 1) + '-' + (goodsindex + 1),
                    item
                  )
                "
              >
                <img
                  :ref="'video_banner-' + index + '-' + goodsindex"
                  :src="goodsitem.videourl"
                  @error="
                    (event) => {
                      let img = event.srcElement
                      img.src = errorImg
                      img.onerror = null
                    }
                  "
                />
              </div>
              <div
                class="goods"
                @click="
                  bannerClick(
                    goodsitem,
                    goodsindex,
                    'rtc-' + (index + 1) + '-' + (goodsindex + 1),
                    item
                  )
                "
              >
                <div
                  v-if="goodsitem.type == 1 && goodsitem.videourl && goodsitem.is_play"
                  class="click_play"
                  @click.stop="videoClick(index, goodsindex)"
                >
                  <div class="circle">
                    <div class="circle circleCh circleCh1 flex-jc-ac">
                      <van-icon color="#ffffff" size="0.13rem" name="play" />
                    </div>
                  </div>
                </div>
                <img class="goodsimg" :src="goodsitem.goodsimg" />
                <div
                  :path="
                    goodsitem.ad_target +
                    (goodsitem.ad_target.indexOf('?') >= 0 ? '&' : '?') +
                    'sorce=8'
                  "
                  :username="'gh_5d4bb8e18b8b'"
                  class="slide_cl_xcx"
                  v-if="isWx && (goodsitem.ad_type == 7 || goodsitem.ad_type == 8)"
                ></div>
              </div>
              <div
                class="goods1"
                v-if="goodsitem.actimg"
                :class="{ goods1_transform: item.videoIndex == goodsindex && item.goodsTransform }"
                @click="
                  bannerClick(
                    goodsitem,
                    goodsindex,
                    'rtc-' + (index + 1) + '-' + (goodsindex + 1),
                    item
                  )
                "
              >
                <img class="goodsimg" :src="goodsitem.actimg" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="series">
        <van-collapse v-model="seriesNames">
          <van-collapse-item
            ref="collapseItem"
            v-for="(item, index) of serieslist"
            :key="index"
            :name="index"
          >
            <template slot="title">
              <div class="title">
                <img
                  :src="item.banner_img"
                  @click="
                    $clickburiedPoint({
                      data: { buttonCode: 'class-' + (index + 1), buttontext: item.name }
                    })
                  "
                  @error="
                    (event) => {
                      let img = event.srcElement
                      img.src = errorImg
                      img.onerror = null
                    }
                  "
                />
              </div>
            </template>
            <div class="seriesgoods" v-if="item.goodslist.length">
              <swiper id="seriesBanner" :options="seriesSwiper" style="height: 100%">
                <swiper-slide
                  ref="activityItem"
                  v-for="(itemSon, indexSon) of item.goodslist"
                  :key="indexSon"
                >
                  <img
                    :src="itemSon.goods_img"
                    @click="goDetail(itemSon, indexSon, 'classprod-' + itemSon.item_id, item.name)"
                    @error="
                      (event) => {
                        let img = event.srcElement
                        img.src = errorImg
                        img.onerror = null
                      }
                    "
                  />
                </swiper-slide>
                <div slot="pagination" class="swiper-pagination seriesSwiperPagination"></div>
              </swiper>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div
        class="salserank"
        v-if="salseranknavlist.length"
        :class="{ salserankBack: isFixedSalserank }"
        :style="salseranknavlist.length ? { 'min-height': salserankheight / 100 + 'rem' } : {}"
      >
        <van-tabs
          v-model="salserank"
          @click="salserankClick"
          z-index="200"
          :ellipsis="false"
          sticky
          :offset-top="follow ? '0.89rem' : '0.4rem'"
          @scroll="scrollTopSalserank"
        >
          <van-tab
            v-for="(item, index) in salseranknavlist"
            :key="index"
            :disabled="index != salserank && tabDisabled"
          >
            <template #title>
              <div class="salseranknav">
                <p class="f15">{{ item.tagname }}</p>
                <span class="f11">{{ item.tagsubtitle }}</span>
              </div>
            </template>
          </van-tab>
          <div class="list" ref="list">
            <div class="listItem" ref="listItem1">
              <product-item
                v-for="(item, index) of salseranklist1"
                :key="index"
                :prolistItem="item"
                :prolistIndex="index"
                :type="'lazyloading'"
                :skuSwitch="'1'"
                @showSku="showSku"
                :markPointData="{
                  scenepoint: 'MAIN',
                  scenedesc: salseranknavlist[salserank].tagname,
                  scenefrom: 'itemclass-' + (salserank + 1)
                }"
              ></product-item>
            </div>
            <div class="listItem" ref="listItem2">
              <product-item
                v-for="(item, index) of salseranklist2"
                :key="index"
                :prolistItem="item"
                :prolistIndex="index"
                :type="'lazyloading'"
                :skuSwitch="'1'"
                @showSku="showSku"
                :markPointData="{
                  scenepoint: 'MAIN',
                  scenedesc: salseranknavlist[salserank].tagname,
                  scenefrom: 'itemclass-' + (salserank + 1)
                }"
              ></product-item>
            </div>
          </div>
        </van-tabs>
      </div>
    </Scroller>
    <div class="floatBtn" v-show="!showsku">
      <img @click="goquan" src="/static/images/quan.png" v-if="showquan == true" />
      <img v-if="stickShow" @click="stick" src="../../assets/images/stick.png" />
      <!--    皮肤测试入口屏蔽-->
      <!--    <img @click="goSkinTest" src="/static/images/skintest.gif">-->
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
      <img v-if="is_private" @click="groupQr" src="/static/images/groupicon.png" />
      <!--    <div class="imgLive" @click="goLiveList">-->
      <!--      <img src="../../assets/images/live.png">-->
      <!--      <div class="slide_cl_xcx" path="/pages/personalcenter/pages/livelist/main.html?sorce=3"></div>-->
      <!--    </div>-->
      <img @click="keFu" src="../../assets/images/service1.png" />
    </div>
    <div
      class="floatadvert"
      :style="{
        width: +privatefloat.width / 100 + 'rem',
        height: +privatefloat.height / 100 + 'rem'
      }"
      v-if="privatefloat.img_path"
      @click="bannerClick(privatefloat, 0, 'ad-1')"
      @touchstart="dragStart"
      @touchmove="dragMove"
      @touchend="dragEnd"
    >
      <img
        :style="{
          width: +privatefloat.width / 100 + 'rem',
          height: +privatefloat.height / 100 + 'rem'
        }"
        :src="privatefloat.img_path"
      />
    </div>
    <footer-comp v-show="!showsku" :footer-index="index" :cartnum="cartnum"></footer-comp>
    <van-overlay :show="is_pop" v-if="is_pop && popup_ads && popup_ads.img_path" z-index="99999">
      <div class="wrapper" @click="closeAct">
        <div class="block" @click.stop>
          <div style="position: relative">
            <img :src="popup_ads.img_path" @click="goAct('indexpopup')" />
            <div
              :path="
                popup_ads.ad_target +
                (popup_ads.ad_target.indexOf('?') >= 0 ? '&' : '?') +
                'sorce=9'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && (popup_ads.ad_type == 7 || popup_ads.ad_type == 8)"
            ></div>
          </div>
          <van-icon name="close" @click="closeAct" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showCoupon" v-if="showCoupon" z-index="99999">
      <div class="pop-wrap">
        <div class="content-wrap">
          <img class="logo" src="../../assets/images/coupon-btn.png" />
          <p class="name">至臻券</p>
          <p class="label">产品券已放到“我的-产品券”中，请尽快去使用吧！</p>
          <div class="footer-wrap">
            <div class="btn-see" @click="goCouponList">去看看</div>
            <div class="btn-buy" @click="goShopping">去下单</div>
          </div>
        </div>
        <van-icon name="close" @click="closeCoupon" />
      </div>
    </van-overlay>
    <van-overlay :show="redPacketShow == 1" v-if="redPacketShow == 1" z-index="99999">
      <div @click="closeAct" class="wrapper">
        <div class="block" @click.stop style="width: 100%">
          <img
            @click="goAct('indexpopup', 'redPacket')"
            src="/static/images/act100w/redPacket.gif"
          />
          <van-icon name="close" @click="closeAct" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showcouponget" v-if="showcouponget" z-index="99">
      <div class="wrapper">
        <div class="block">
          <img class="couponget" src="/static/images/coupon/couponget.gif" @click="receive(0)" />
          <van-icon name="close" size="0.2rem" @click="showcouponget = false" />
          <!--    <van-button round plain  type="danger" class="know"  @click="showcoupon5 = false">X</van-button>-->
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showcouponget1" v-if="showcouponget1" z-index="99">
      <div class="wrapper">
        <div class="block">
          <img src="/static/images/coupon/couponget1.png" @click="receive1" />
          <van-icon name="close" size="0.2rem" @click="showcouponget1 = false" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showcouponget2" v-if="showcouponget2" z-index="99">
      <div class="wrapper">
        <div class="block">
          <img @click="receive1" src="/static/images/coupon/couponget2.png" />
          <van-icon
            @click="showcouponget2 = false"
            class="know close close1"
            name="close"
            size="0.3rem"
          />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showcoupon5" v-if="showcoupon5" z-index="99">
      <div class="wrapper">
        <div class="block positionblock">
          <div class="img">
            <img src="/static/images/coupon/coupon5.png" @click="goCoupon" />
            <p>有效期：{{ info.usestarttime + '-' + info.useendtime }}</p>
          </div>
          <van-icon @click="showcoupon5 = false" name="close" size="0.3rem" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showcoupon10" v-if="showcoupon10" z-index="99">
      <div class="wrapper">
        <div class="block positionblock">
          <div class="img">
            <img src="/static/images/coupon/coupon10.png" @click="goCoupon" />
            <p>有效期：{{ info.usestarttime + '-' + info.useendtime }}</p>
          </div>
          <van-icon @click="showcoupon10 = false" name="close" size="0.3rem" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showcoupon0326" v-if="showcoupon0326" z-index="99">
      <div class="sharecontainer couponpopup wrapper">
        <div class="img">
          <img
            :src="specialPopJSON.popads.pop_img_url"
            @click="specialPopFn(specialPopJSON.popads)"
          />
          <div
            :path="
              specialPopJSON.popads.pop_ad_target +
              (specialPopJSON.popads.pop_ad_target.indexOf('?') >= 0 ? '&' : '?') +
              'sorce=12'
            "
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="
              isWx &&
              (specialPopJSON.popads.pop_ad_type == 7 || specialPopJSON.popads.pop_ad_type == 8)
            "
          ></div>
        </div>
        <van-icon @click="showcoupon0326 = false" class="know close" name="close" size="0.3rem" />
      </div>
    </van-overlay>
    <!-- 2021-4-26新增金币雨活动 -->
    <van-overlay :show="showcoupon0426" v-if="showcoupon0426" z-index="99999">
      <div class="wrapper">
        <div class="block1">
          <img @click="goldRainFun" src="../../assets/images/goldenrain.gif" />
        </div>
      </div>
    </van-overlay>
    <!-- 2021-9-20 引流活动相关弹窗 -->
    <van-overlay :show="showdrainage" v-if="showdrainage" z-index="99999">
      <div class="wrapper">
        <div class="block">
          <img :src="drainage.pop_img_url" @click="drainageFn" />
          <van-icon @click="showdrainage = false" name="close" size="0.3rem" />
        </div>
      </div>
    </van-overlay>
    <!-- 2021-11-26 短信通知弹窗 -->
    <van-overlay :show="issmspop.ispop == 1" v-if="issmspop && issmspop.ispop" z-index="99999">
      <div class="wrapper">
        <div class="block">
          <div class="back_write">
            <img src="/static/images/sms/bg.png" />
            <div class="text">
              <img src="/static/images/sms/notify.png" />
              亲爱的金粉，为了方便您及时参与福利活动，活动特惠期会为您推送短信通知
            </div>
            <button @click="gosms(1)">立即开启</button>
            <p @click="gosms(0)">下次再说</p>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 2022-03-08 预约活动弹窗 -->
    <van-overlay
      :show="subscribe_pop && subscribe_pop.ispop == 1"
      v-if="subscribe_pop.ispop == 1 && subscribe_pop.pop_img_url != ''"
      z-index="99999"
    >
      <div class="wrapper" @click="closeAct">
        <div class="block" @click.stop>
          <div>
            <img :src="subscribe_pop.pop_img_url" @click="goAct('indexpopup', 'subscribepopup')" />
          </div>
          <van-icon name="close" @click="closeAct" />
        </div>
      </div>
    </van-overlay>
    <!-- 2022-03-16首页弹窗，活动期间仅普通钜惠店主及50VIP钜惠店主弹，弹窗点击进入配置分级产品链接页面 -->
    <van-overlay :show="is_pop50" v-if="is_pop50 && timeOneDay" z-index="99999">
      <div class="wrapper" @click="closeAct">
        <div class="block" @click.stop>
          <div style="position: relative">
            <img :src="pop50_img_url" @click="goAct('indexpopup', 'pop50popup')" />
          </div>
          <van-icon name="close" @click="closeAct" />
        </div>
      </div>
    </van-overlay>
    <!--2022-7周年回忆杀弹窗-->
    <van-overlay
      :show="yearlivepop.ispop"
      v-if="yearlivepop.ispop && yearlivepop.popads && yearlivepop.popads.pop_img_url"
      z-index="99999"
    >
      <div class="wrapper" @click="closeAct">
        <div class="block" @click.stop>
          <div style="position: relative">
            <p
              style="
                position: absolute;
                left: 41.5%;
                top: 27.5%;
                font-size: 0.14rem;
                color: #ffffff;
                margin-top: 0;
              "
            >
              {{ yearlivepop.popads.pop_username }}
            </p>
            <img
              :src="yearlivepop.popads.pop_img_url"
              @click="goAct('yearlivepop', 'yearlivepop')"
            />
            <div
              :path="
                yearlivepop.popads.pop_ad_target +
                (yearlivepop.popads.pop_ad_target.indexOf('?') >= 0 ? '&' : '?') +
                'sorce=12'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && yearlivepop.popads.pop_ad_type == 2"
            ></div>
          </div>
          <van-icon name="close" @click="closeAct" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import productItem from '../common/productItem'
import footerComp from '../common/footerComp'
import follow from '../common/follow'
import Scroller from '../common/Scroller'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import '../../assets/css/zy.media.css'
import zymedia from '../../assets/js/zy.media'
import {
  browHistory,
  fenxiang,
  formateMobile,
  formateName,
  getCookie,
  isWeixin,
  kefu,
  setCookie,
  popType,
  clearPopCache,
  bannerClick,
  goXcxCreateBtnFn
} from '../../assets/common/js/config'
import { Swipe, SwipeItem } from 'vant'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */).use(Swipe).use(SwipeItem)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
export default {
  name: 'homePage',
  components: {
    productItem,
    footerComp,
    follow,
    Scroller,
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  data() {
    var that = this
    return {
      index: 0,
      tagShow: false,
      signinShow: null,
      searchType: 0,
      bannerSwiper: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        initialSlide: 0,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        slidesOffsetAfter: 20,
        watchOverflow: true,
        pagination: {
          el: '#bannerSwiperPagination',
          // clickable: true,
          type: 'bullets'
        },
        on: {
          slideChangeTransitionStart: function () {
            that.activeIndex = this.realIndex
          },
          click: function () {
            var activeIndex = this.realIndex
            that.bannerClick(
              that.bannerlist[activeIndex],
              activeIndex,
              'banner-' + (activeIndex + 1)
            )
          }
        }
      },
      categorySwiper: {
        autoplay: false,
        autoplayDisableOnInteraction: false,
        slidesPerView: 0,
        slidesPerGroup: 1,
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        pagination: {
          el: '#newProSwiperPaginationOne',
          type: 'bullets'
        }
      },
      activitySwiper: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        // width: 330,
        centeredSlides: true,
        centeredSlidesBounds: true,
        // slidesOffsetBefore: 105,
        // slidesOffsetAfter: 108,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        slidesPerView: 2.28,
        slidesPerGroup: 1,
        on: {
          click: function () {
            // console.log(this.clickedSlide.className.indexOf('swiper-slide-prev'))swiper-slide-prev
            var next,
              prev,
              activeIndex = this.realIndex
            if (this.clickedSlide.className.indexOf('swiper-slide-next') >= 0) {
              if (activeIndex == that.activitylist.length - 1) {
                activeIndex = 0
              } else {
                activeIndex = activeIndex + 1
              }
            } else if (this.clickedSlide.className.indexOf('swiper-slide-prev') >= 0) {
              if (activeIndex == 0) {
                activeIndex = that.activitylist.length - 1
              } else {
                activeIndex = activeIndex - 1
              }
            }
            that.bannerClick(
              that.activitylist[activeIndex],
              activeIndex,
              'act-' + (activeIndex + 1)
            )
          }
        },
        pagination: {
          el: '#activitySwiperPagination',
          // clickable: true,
          type: 'bullets'
        }
      },
      videogoodsSwiper: {
        loop: true,
        loopAdditionalSlides: 3,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        // width: 330,
        centeredSlides: true,
        centeredSlidesBounds: true,
        // slidesOffsetBefore: 105,
        // slidesOffsetAfter: 108,
        spaceBetween: -25,
        observer: true,
        observeParents: true,
        slidesPerView: 1.53,
        slidesPerGroup: 1,
        on: {
          slideChangeTransitionStart() {
            var i = parseInt(this.$el[0].attributes['index'].value)
            that.videogoodslist[i].videoIndex = this.realIndex
          }
        }
      },
      seriesSwiper: {
        freeMode: true,
        autoplay: false,
        autoplayDisableOnInteraction: false,
        slidesPerView: 3,
        slidesPerGroup: 1,
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        pagination: {
          el: '.seriesSwiperPagination',
          type: 'bullets'
        }
      },
      currscroll: 0,
      lastscroll: 0,
      isheaderwidth: 0,
      isheadertop: 0,
      defaultSearch: '',
      activeIndex: 0,
      videoplay: 0,
      is_private: 0,
      searchlist: [],
      bannerbackcolor: '',
      bannerlist: [],
      categorylist: [],
      categorylisttd: [],
      activitylist: [],
      privatesphere: [], // 私域导流入口
      privatefloat: {}, // 私域导流入口
      featuredads: [],
      videogoodslist: [],
      serieslist: [],
      videoIndex: 0,
      goodsTransform: false,
      initialIndex: 0,
      // skinShow: false,
      seriesNames: [],
      salseranknavlist: [],
      salseranklist: [],
      salseranklist1: [],
      salseranklist2: [],
      salserank: 0,
      salserank1: -1,
      onlyone: 0,
      salserankheight: document.body.clientHeight - 57,
      isFixedSalserank: false,
      tagid: '',
      tabDisabled: false,
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 1,
      isWx: isWeixin() ? 1 : 0,
      is_pop: null,
      is_pop50: false,
      timeOneDay: false,
      pop50_img_url: '',
      pop50_ad_target: '',
      showCoupon: null, // 优惠券弹窗
      showcouponget: false,
      showcouponget1: false,
      showcouponget2: false,
      showcoupon5: false,
      showcoupon10: false,
      showcoupon0326: false,
      showcoupon0426: false,
      five_fold_show: 0,
      redPacketShow: 0,
      showstatus: 3, // 新人有礼
      isnewuser: 0, // 是否是新人
      popup_ads: {},
      showquan: false,
      couponsendid: '',
      goldRainData: {}, // 2021-1-26金币雨活动
      goldRainSetTimeout: null,
      showdrainage: false,
      drainage: null,
      jhdzShow: 0, // 钜惠店主入口是否展示
      specialPopJSON: {
        ispop: 0, // 是否弹出
        poptimes: 0, // 弹出次数
        popads: {
          pop_img_url: '',
          pop_ad_type: 1,
          pop_ad_target: ''
        }
      },
      ord_popup_ads: null, // 首页普通弹窗
      info: null,
      showsku: false,
      issmspop: {
        ispop: 0,
        pop_img_url: ''
      },
      noticmsg: '',
      cartnum: 0,
      subscribe_pop: {
        ispop: 0,
        pop_img_url: '',
        pop_ad_target: ''
      },
      countdown: {
        time: 0,
        isshow: 0
      },
      isnewpersontask: 0,
      newpersonjumpurl: '',
      follow: null,
      skinInfo: {},
      birthday_pop: {},
      birthdayinfo_pop: {},
      act_countdown: {},
      yearlivepop: {
        ispop: 0,
        popads: {}
      },
      stickShow: 0,
      isdrag: true,
      prepay_popup: {}, // 38预约活动弹窗
      communityad: {}, // 跳社区广告位
      momday_video: {},
      momday_Height: 0,
      momday_ismuted: true,
      momday_isplay: 1,
      momday_play_init: 1, // 只执行一次，视频播放初始化
      mall_endorsement: {}, // 商城首页-平台背书
      showNewPeople: false,
      newPeopleConfig: {}
    }
  },
  watch: {
    activeIndex(n) {
      this.bannerbackcolor = this.bannerlist[n].color
    }
  },
  mounted() {
    if (sessionStorage.getItem('popFlagBool50') == null) {
      sessionStorage.setItem('popFlagBool50', 1)
    }
    if (!localStorage.getItem('popFlagSub')) {
      localStorage.setItem('popFlagSub', 1)
    }
    if (!localStorage.getItem('popFlag50')) {
      localStorage.setItem('popFlag50', 1)
    }
    if (sessionStorage.getItem('oncePopupFlag') == null) {
      // 只有每次打开商城首页才能触发的弹框（从其他页面返回首页不算）
      sessionStorage.setItem('oncePopupFlag', 1)
    }
    var url = this.$ajax.actNotice_URL
    if (!getCookie('ckc4_act_notice')) {
      this.$customRequestAjax(url).then(function (res) {
        setCookie('ckc4_act_notice', 'actNotice', 5 * 60 * 1000)
      })
    }
    var that = this

    if (this.$route.query.pt === 'ckapp') {
      setCookie('wxmalltoken', this.$route.query.waptoken)
    }

    let wxmalltoken = getCookie('wxmalltoken')
    // if (wxmalltoken && !sessionStorage.getItem('loginFlag')) {
    //   sessionStorage.setItem('loginFlag', 1)
    //   gio('setUserId', wxmalltoken)
    //   this.getUserInfo('gio')
    // } else {
    //   this.getUserInfo()
    // }
    this.getData(() => {
      if (Object.keys(this.act_countdown).length) {
        this.countDown()
      }
      this.hasNewMsg('init')
      if (Number(this.isnewpersontask) == 1) {
        // 新用户顶部图片显示
        this.getNewPeople()
      }
    })
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter: function (to, from, next) {
    if (from.path == '/') {
      // 当前页面刷新不需要切换位置
      next(function (vm) {
        window.addEventListener('scroll', vm.scrollToTop)
        // vm.initialIndex = vm.videoIndex
        vm.getHeadData()
        fenxiang({ path: 'home' })
      })
    } else {
      next(function (vm) {
        window.addEventListener('scroll', vm.scrollToTop)
        // vm.initialIndex = vm.videoIndex
        vm.hasNewMsg()
        vm.getHeadData()
        fenxiang({ path: 'home' })
        // setTimeout(function () {
        //   window.scrollTo(0, sessionStorage.askPositon, false)
        // }, 0) // 同步转异步操作
      })
    }
  },
  beforeRouteLeave: function (to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop) || parseInt(window.pageYOffset)
    this.videogoodslist.map((item) => {
      item.initialIndex = item.videoIndex
    })
    setCookie('iscloseAct', 1, 12 * 60 * 60 * 1000)
    window.removeEventListener('scroll', this.scrollToTop)
    next()
  },
  methods: {
    dragStart: function (e) {
      this.isdrag = true
      this.tempX = parseInt($(e.currentTarget).css('left') + 0)
      this.tempY = parseInt($(e.currentTarget).css('top') + 0)
      this.x = e.touches[0].pageX
      this.y = e.touches[0].pageY
    },
    dragMove: function (e) {
      if (this.isdrag) {
        var curX = this.tempX + e.touches[0].pageX - this.x
        var curY = this.tempY + e.touches[0].pageY - this.y
        //边界判断
        curX = curX < 0 ? 0 : curX
        curY = curY < 0 ? 0 : curY
        curX =
          curX < document.documentElement.clientWidth - $(e.currentTarget).width()
            ? curX
            : document.documentElement.clientWidth - $(e.currentTarget).width()
        curY =
          curY < document.documentElement.clientHeight - 55 - $(e.currentTarget).height()
            ? curY
            : document.documentElement.clientHeight - 55 - $(e.currentTarget).height()
        $(e.currentTarget).css({ left: curX, top: curY })
        //禁止浏览器默认事件
        e.preventDefault()
      }
    },
    dragEnd: function () {
      this.isdrag = false
    },
    followFn: function (data) {
      this.follow = data
    },
    showSku: function (n) {
      // console.log(n)
      this.showsku = n
    },
    search: function (item) {
      if (item.searchtext) {
        this.$router.push({
          path: '/searchlist',
          query: {
            searchval: encodeURIComponent(item.searchtext),
            searchType: this.searchType
          }
        })
      } else {
        this.$toast('请正确输入查询内容')
      }
    },
    countDown() {
      let nowtime = new Date().getTime(),
        starttime = new Date(this.act_countdown.starttime.replace(/-/g, '/')).getTime(),
        endtime = new Date(this.act_countdown.endtime.replace(/-/g, '/')).getTime()
      if (nowtime < starttime) {
        this.countdown.time = starttime - nowtime
        this.countdown.isshow = 1
      } else if (nowtime < endtime && nowtime >= starttime) {
        this.countdown.time = endtime - nowtime
        this.countdown.isshow = 2
      } else {
        this.countdown.isshow = 0
      }
    },
    finishFn() {
      this.countDown()
    },
    // -- 废弃-- 皮肤测试
    // skinTest () {
    //   let that = this
    //   if (!isWeixin()) {
    //     if (this.waptoken.waptoken && this.waptoken.waptoken != this.waptoken.tourists) {
    //       f()
    //     }
    //   } else {
    //     f()
    //   }
    //   function f() {
    //     let url = that.$ajax.getNdoResult_URL
    //     that.$customRequestAjax(url).then(res => {
    //       if (res.data.code === 200) {
    //         that.skinInfo = res.data
    //       }
    //     })
    //   }
    // },

    // --废弃-- 首页弹窗，活动期间仅普通钜惠店主及50VIP钜惠店主弹，弹窗点击进入配置分级产品链接页面(一天弹一次)
    // get50VipPopShow() {
    //   var that = this
    //   var url = this.$ajax.jhShopPop_URL
    //   try {
    //      this.$customRequestAjax(url).then(function (res) {
    //         // console.log("获取到的data1111",res.data)
    //         let isshow = res.data.ispop
    //         that.pop50_img_url = res.data.pop_img_url
    //         that.pop50_ad_target = res.data.pop_ad_target
    //         let day = new Date().getTime();
    //         if (isshow == 1) { //1显示、0不显示
    //         that.is_pop50= true
    //         if(!localStorage.getItem('pop50_day')){
    //            that.timeOneDay = true
    //            localStorage.setItem('pop50_day', day)
    //            localStorage.setItem('po50_num', 1)
    //         }else{
    //           if(day-localStorage.getItem('pop50_day')>86400000){
    //             localStorage.removeItem('pop50_day')
    //             localStorage.removeItem('po50_num')
    //           }
    //           if(localStorage.getItem('po50_num')!='111'){
    //             that.timeOneDay = true
    //             localStorage.setItem('pop50_day', day)
    //             let num = localStorage.getItem('po50_num')
    //             localStorage.setItem('po50_num',num+1)
    //           }else{
    //             that.timeOneDay = false
    //             that.subscribePop()
    //           }
    //         }
    //         } else {
    //           that.is_pop50= false
    //           that.subscribePop()
    //         }
    //     })
    //   } catch (e) {
    //   }
    // },

    // 未读消息
    async hasNewMsg(type) {
      let { data } = await this.$customRequestAjax(this.$ajax.hasNewMsg_URL)
      this.tagShow = data.data.has_new_msg
      this.noticmsg = data.data.noticmsg
      this.cartnum = data.data.cartnum ? data.data.cartnum : 0
      if (data.data.act_status == 1) {
        this.showquan = true
      } else {
        this.showquan = false
      }
      if (type == 'init') this.birthdayPopInfo()
    },
    goquan: function () {
      this.$router.push('/getcoupon')
    },
    //  --废弃-- 预约活动弹窗
    // async subscribePop () {
    //   let {data} = await this.$customRequestAjax(this.$ajax.getPresalePopu_URL)
    //   let popFlag = localStorage.getItem('popFlagSub') ? parseInt(localStorage.getItem('popFlagSub')) : 1
    //   if (data.ispop == 1 && popFlag > 0 && popFlag <= 2) {
    //     let day = new Date(new Date().toLocaleDateString()).getTime();
    //     let oldDay = localStorage.getItem('day') ? localStorage.getItem('day') : null
    //     if (!localStorage.getItem('day') || (oldDay != null && day == oldDay)) {
    //       localStorage.setItem('day', day)
    //       this.subscribe_pop = Object.assign({}, this.subscribe_pop, data)
    //       localStorage.setItem('popFlagSub', ++popFlag)
    //     } else {
    //       if (oldDay != day) {
    //         localStorage.setItem('day', day)
    //         this.subscribe_pop = Object.assign({}, this.subscribe_pop, data)
    //         localStorage.setItem('popFlagSub', 2)
    //       }
    //     }
    //   } else {
    //     this.Drainage() // 2021-9-20 引流活动相关弹窗
    //   }
    // },

    // 短信通知授权
    async smsPop() {
      let { data } = await this.$customRequestAjax(this.$ajax.showMsgPop_URL)
      if (data.ispop) {
        this.popType(3, data, 'smsPop', () => {
          this.issmspop = Object.assign({}, this.issmspop, data)
        })
      }
      if (!this.issmspop || !this.issmspop.ispop) {
        this.fifthVipGiftPopup()
      }
    },
    async gosms(type) {
      let { data } = await this.$customRequestAjax.post(this.$ajax.doMsgPop_URL, {
        isagree: type
      })
      if (data.code == 200) {
        this.issmspop.ispop = 0
        // this.$toast(data.msg)
      }
    },
    //  --废弃-- 埋点
    // getUserInfo: function (type) {
    //   var url = this.$ajax.getMeInfo_URL
    //   this.$customRequestAjax(url).then(res => {
    //     if (res.data.code === 200) {
    //       this.cartnum = res.data.cartnum
    //       if (!getCookie('loginType') && type == 'gio') {
    //         let smallname = formateName(res.data.smallname)
    //         let mobile = formateMobile(res.data.mobile)
    //         gio('people.set', 'userContact_ppl', mobile)
    //         gio('people.set', 'userName_ppl', smallname)
    //         gio('people.set', 'gender_ppl', res.data.sex)
    //         setCookie('loginType', 1)
    //       }
    //     }
    //   })
    // },

    // 点击图片进行跳转
    specialPopFn(item) {
      // let src = this._specialPopFn(item);
      if (item.pop_ad_target) window.location.href = item.pop_ad_target
    },
    // 企微二维码弹窗
    async specialPop() {
      let { data } = await this.$customRequestAjax(this.$ajax.getPopupInfo_URL)
      if (data.code === 200) {
        if (data.data.ispop == 1) {
          this.popType(parseInt(data.data.poptimes), data.data, 'specialPop', () => {
            this.specialPopJSON = Object.assign({}, this.specialPopJSON, data.data)
            this.showcoupon0326 = true
          })
        }
        if (!this.showcoupon0326) {
          this.getOrderCoupon()
        }
      } else {
        this.getOrderCoupon()
      }
    },
    //  --废弃-- 2021-9-20 引流活动相关弹窗
    // Drainage: function () {
    //   var that = this
    //   var url = this.$ajax.getIndexPopu_URL
    //   try {
    //     this.$customRequestAjax(url).then(function (res) {
    //       if (res.data.code === 200) {
    //         if (Object.keys(res.data.popup_ads).length > 0) {
    //           if (sessionStorage.getItem('oncePopupFlag') == 1) {
    //             that.drainage = res.data.popup_ads
    //             that.showdrainage = true
    //             sessionStorage.setItem('oncePopupFlag', 0)
    //           }
    //           that.goXcxCreateBtnFn()
    //         } else {
    //           that.goldRainAction()
    //         }
    //       } else {
    //         that.goldRainAction()
    //       }
    //     })
    //   } catch (e) {
    //     that.goldRainAction()
    //   }
    // },

    drainageFn: function () {
      var that = this
      this.$buriedPoint({
        behavior: '100',
        userfrom: 2
      })
      window.location.href = that.drainage.url
    },
    //  --废弃-- 2021-4-26新增金币雨活动
    // goldRainAction() {
    //   var that = this
    //   var url = this.$ajax.getGoldByActivity_URL
    //   try {
    //     this.$customRequestAjax(url).then(function (res) {
    //       if (res.data.code === 200) {
    //         if (res.data.data.ispop) {
    //           that.showcoupon0426 = true
    //           that.goldRainData = res.data.data;
    //           that.goldRainSetTimeout = setTimeout(function () {
    //             that.showcoupon0426 = false
    //             window.location.href = that.goldRainData.pop_target + '?' + 'goldencoinmoney=' + that.goldRainData.goldencoinmoney
    //           }, 7000)
    //           sessionStorage.setItem('oncePopupFlag', 0)
    //           // console.log('金币雨活动')
    //           that.goXcxCreateBtnFn()
    //         } else {
    //           that.birthdayPop()
    //         }
    //       } else {
    //         that.birthdayPop()
    //       }
    //     })
    //   } catch (e) {
    //     that.birthdayPop()
    //   }
    // },

    // 2022-6-17 会员特权生日折扣弹窗
    birthdayPop() {
      this.popType(1, this.birthday_pop, 'birthday')
      if (!this.is_pop) {
        this.getNewInfo()
      }
    },
    // 2023-4-26 完善生日信息弹窗
    async birthdayPopInfo() {
      let { data } = await this.$customRequestAjax(this.$ajax.getUserBirthdayPop_URL)
      if (data.code === 200) {
        if (data.popup_ads.img_path) {
          this.birthdayinfo_pop = data.popup_ads
          this.popType(1, this.birthdayinfo_pop, 'birthdayinfo', null, 'month')
        }
        if (!this.is_pop) {
          this.birthdayPop()
        }
      } else {
        this.birthdayPop()
      }
    },
    //  判断是否为新用户，显示新人客服二维码
    getNewPeople() {
      this.popType(2, this.newPeopleConfig, 'newPeoplePop', () => {
        this.showNewPeople = true
        this.newPeopleHeight = this.newPeopleConfig.img_list.reduce((acc, o) => {
          return acc + Number(o.img_height)
        }, 0)
        this.newPeopleHeight =
          (this.newPeopleHeight *
            (document.documentElement.clientWidth || document.body.clientWidth)) /
          750
      })
    },
    // 判断是否为新用户 新人有礼弹窗
    getNewInfo: function () {
      // var that = this
      // var url = this.$ajax.checkActivityShow_URL
      // try {
      //   this.$customRequestAjax(url).then(function (res) {
      //     if (res.data.code === 200) {
      //       that.popup_ads = res.data.popup_ads
      //       that.showstatus = res.data.showstatus
      //       that.isnewuser = res.data.isnewuser
      //       if (that.showstatus == 1) {
      //         that.popType(1, res.data.popup_ads, 'newUserPop', () => {
      //           that.is_pop = 1;
      //         })
      //       }
      //       if (that.is_pop != 1) {
      //         that.prepayPopup()
      //       }
      //     } else {
      //       that.prepayPopup()
      //     }
      //   })
      // } catch (e) {
      //   that.prepayPopup()
      // }
      this.prepayPopup()
    },
    prepayPopup: function () {
      if (Object.keys(this.prepay_popup).length > 0) {
        this.popType(3, this.prepay_popup, 'prepayPop')
      } else {
        this.ordPopFn()
      }
    },
    //  --废弃-- 2022-7周年回忆杀弹窗
    // getYearLivePopupInfo: function () {
    //   var that = this
    //   var url = this.$ajax.getYearLivePopupInfo_URL
    //   try {
    //     this.$customRequestAjax(url).then(function (res) {
    //       if (res.data.code === 200) {
    //         if (res.data.data.ispop == 1) {
    //           that.popType(3, res.data.data, 'getYearLivePop', () => {
    //             res.data.data.popads.pop_username = res.data.data.popads.pop_username.length > 6 ? (res.data.data.popads.pop_username.slice(0, 6) + '...') : res.data.data.popads.pop_username
    //             that.yearlivepop = Object.assign({}, that.yearlivepop, res.data.data)
    //           })
    //         } else {
    //           that.ordPopFn()
    //         }
    //       } else {
    //         that.ordPopFn()
    //       }
    //     })
    //   } catch (e) {
    //     that.ordPopFn()
    //   }
    // },

    // 订单发券弹窗:有新发的券则显示
    getOrderCoupon: function () {
      var that = this
      var url = this.$ajax.getOrderCoupon_URL
      try {
        this.$customRequestAjax(url).then(function (res) {
          if (res.data.code === 200) {
            if (res.data.coupon_id) {
              that.handleCouponId(res.data.coupon_id)
              that.goXcxCreateBtnFn()
            } else {
              that.smsPop()
            }
          } else {
            that.smsPop()
          }
        })
      } catch (e) {
        that.smsPop()
      }
    },
    handleCouponId(couponId) {
      let oldCouponId = localStorage.getItem('couponId')
      if (!oldCouponId) {
        this.showCoupon = true
        localStorage.setItem('couponId', couponId)
      } else if (oldCouponId != couponId) {
        this.showCoupon = true
        localStorage.setItem('couponId', couponId)
      }
    },
    //  --废弃--红包雨活动
    // oneHundPopup: function () {
    //   var that = this
    //   var url = this.$ajax.checkActivityShow_act_URL
    //   try {
    //     this.$customRequestAjax.post(url).then((res) => {
    //       if (res.data.code == 200) {
    //         if (res.data.data.actstatus == 0 || res.data.data.actstatus == 1) {
    //           // 0活动未开始 1活动已结束 2已领取 3未领取
    //           // 如果活动未开始或者活动已结束，那么就弹出VIP礼包弹框
    //           that.fifthVipGiftPopup()
    //           // console.log('红包雨活动未开始或已结束')
    //         } else {
    //           if(res.data.data.actstatus == 3){
    //             // 如果红包未领取,那就弹出弹框领取红包
    //             if (res.data.data.type == 0) {
    //               // res.data.data.type == 0百万红包 1临时红包
    //               that.info = res.data.data
    //               that.couponsendid = res.data.data.couponsendid
    //               if (!sessionStorage.getItem('one-hund-popup')) {
    //                 if (res.data.data.ispop == 1) { //  ispop 0: 已参加（不弹） 1:未参加（弹） 2: 未使用
    //                   if (sessionStorage.getItem('oncePopupFlag') == 1) {
    //                     sessionStorage.setItem('one-hund-popup', 1)
    //                     that.showcouponget = true
    //                     sessionStorage.setItem('oncePopupFlag', 0)
    //                   }
    //                 } else if (res.data.data.ispop == 2) {
    //                   if (sessionStorage.getItem('oncePopupFlag') == 1) {
    //                     sessionStorage.setItem('one-hund-popup', 1)
    //                     if (res.data.data.randomtype == 0) { // randomtype 0: 5元 1: 10元
    //                       that.showcouponget1 = true;
    //                     } else if (res.data.data.randomtype == 1) {
    //                       that.showcouponget2 = true
    //                     }
    //                     sessionStorage.setItem('oncePopupFlag', 0)
    //                   }
    //                 }
    //                 that.goXcxCreateBtnFn()
    //               } else {
    //                 that.fifthVipGiftPopup()
    //               }
    //             } else if (res.data.data.type == 1) {
    //               if (
    //                 !sessionStorage.getItem('one-hund-popup') ||
    //                 sessionStorage.getItem('one-hund-popup') == 1
    //               ) {
    //                 if (res.data.data.ispop == 1) {
    //                   if (sessionStorage.getItem('oncePopupFlag') == 1) {
    //                     sessionStorage.setItem('one-hund-popup', 2)
    //                     that.redPacketShow = res.data.data.type
    //                     that.receive(1)
    //                     sessionStorage.setItem('oncePopupFlag', 0)
    //                   }
    //                 } else {
    //                   that.redPacketShow = 0
    //                 }
    //                 that.goXcxCreateBtnFn()
    //               } else {
    //                 that.fifthVipGiftPopup()
    //               }
    //             }
    //           }else{
    //             that.fifthVipGiftPopup();
    //           }
    //         }
    //       } else if (res.data.code == 200 && res.data.msg.indexOf('您已经领过了') >= 0) {
    //         that.fifthVipGiftPopup()
    //       } else {
    //         that.fifthVipGiftPopup()
    //       }
    //     })
    //   } catch (e) {
    //     that.fifthVipGiftPopup()
    //   }
    // },
    // 2021-4-22新增50vip礼包弹框
    fifthVipGiftPopup() {
      var that = this
      let url = this.$ajax.getVipPopads_URL
      try {
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            that.jhdzShow = res.data.data.can_join
            if (res.data.data.is_pop) {
              if (
                !that.is_pop &&
                !that.showCoupon &&
                !that.showcouponget &&
                !that.showcouponget1 &&
                !that.showcouponget2 &&
                !that.showcoupon0426 &&
                !that.showdrainage
              ) {
                let popFlag50 = localStorage.getItem('popFlag50')
                let vipPopIsShow = new Date(new Date().toLocaleDateString()).getTime()
                if (+sessionStorage.getItem('popFlagBool50')) {
                  // console.log('50vip弹框')
                  if (!localStorage.getItem('vipPopIsShow')) {
                    if (sessionStorage.getItem('oncePopupFlag') == 1) {
                      localStorage.setItem('vipPopIsShow', vipPopIsShow)
                      that.is_pop = res.data.data.is_pop
                      that.popup_ads = res.data.data.popup_ads
                      localStorage.setItem('popFlag50', +popFlag50 + 1)
                      sessionStorage.setItem('popFlagBool50', 0)
                      sessionStorage.setItem('oncePopupFlag', 0)
                    }
                  } else {
                    let oldDay = localStorage.getItem('vipPopIsShow')
                    if (oldDay != vipPopIsShow) {
                      if (sessionStorage.getItem('oncePopupFlag') == 1) {
                        localStorage.setItem('popFlag50', 1)
                        localStorage.setItem('vipPopIsShow', vipPopIsShow)
                        that.is_pop = res.data.data.is_pop
                        that.popup_ads = res.data.data.popup_ads
                        sessionStorage.setItem('popFlagBool50', 0)
                        sessionStorage.setItem('oncePopupFlag', 0)
                      }
                    } else {
                      // 50vip每天弹两次
                      if (popFlag50 <= 2) {
                        if (sessionStorage.getItem('oncePopupFlag') == 1) {
                          that.is_pop = res.data.data.is_pop
                          that.popup_ads = res.data.data.popup_ads
                          localStorage.setItem('popFlag50', +popFlag50 + 1)
                          sessionStorage.setItem('popFlagBool50', 0)
                          sessionStorage.setItem('oncePopupFlag', 0)
                        }
                      }
                    }
                  }
                }
              }
            }
            that.goXcxCreateBtnFn()
          }
        })
      } catch (e) {}
    },

    getHeadData: function () {
      var that = this
      var urlHead = this.$ajax.getTopMessage_URL
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken != this.waptoken.tourists) {
          this.$customRequestAjax(urlHead).then(function (res) {
            if (res.data.code == 200) {
              that.signinShow = res.data ? res.data.is_signin : null
              localStorage.setItem('ckc4_home_top_message', JSON.stringify(res.data))
              setCookie('ckc4_home_top_message', 'topMessage', 2 * 60 * 60 * 1000)
            }
          })
        }
      } else {
        this.$customRequestAjax(urlHead).then(function (res) {
          if (res.data.code == 200) {
            that.signinShow = res.data ? res.data.is_signin : null
            localStorage.setItem('ckc4_home_top_message', JSON.stringify(res.data))
            setCookie('ckc4_home_top_message', 'topMessage', 2 * 60 * 60 * 1000)
          }
        })
      }
    },
    newpersontask: function () {
      window.location.href = this.newpersonjumpurl
    },
    getData(fn) {
      let url = this.$ajax.getIndex_URL
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.skinInfo = res.data.ndoresult ? res.data.ndoresult : {}
          this.act_countdown =
            res.data.act_countdown && Object.keys(res.data.act_countdown).length
              ? res.data.act_countdown
              : {}
          this.isnewpersontask = res.data.isnewpersontask ? res.data.isnewpersontask : 0
          this.newPeopleConfig = res.data.newperson_info ? res.data.newperson_info : {}
          this.newpersonjumpurl = res.data.newpersonjumpurl ? res.data.newpersonjumpurl : ''
          this.is_private = res.data.is_private ? res.data.is_private : 0
          this.searchlist = res.data.searchList
          this.bannerlist = res.data.bannerlist
          this.categorylist = res.data.categorylist
          this.categorySwiper.slidesPerView =
            this.categorylist.length >= 5 ? 5 : this.categorylist.length
          this.activitylist = res.data.activitylist
          this.privatesphere = res.data.privatesphere ? res.data.privatesphere : []
          this.communityad = res.data.communityad ? res.data.communityad : {}
          this.featuredads = res.data.featuredads
          this.privatefloat = res.data.privatefloat ? res.data.privatefloat : {}
          this.momday_video = res.data.momday_video ? res.data.momday_video : {}
          this.mall_endorsement = res.data.mall_endorsement ? res.data.mall_endorsement : {}
          if (Object.keys(this.momday_video).length > 0) {
            let p_h = parseFloat(this.momday_video.height) / parseFloat(this.momday_video.width)
            this.momday_Height = ((document.body.clientWidth / 100 - 0.22) * 100 * p_h) / 100
            console.log(this.momday_Height)
          }
          var videogoodslist = res.data.videonewgoods.map((item) => {
            item.videoIndex = 0
            item.goodsTransform = false
            item.videoplay = 0
            item.initialIndex = 0
            item.goodsList.map((goodsItem) => {
              goodsItem.is_play = 1
            })
            return item
          })
          this.videogoodslist = videogoodslist
          // console.log(this.videogoodslist)
          this.serieslist = res.data.serieslist
          for (var i = 0; i < this.serieslist.length; i++) {
            this.seriesNames.push(i)
          }
          this.$nextTick(() => {
            this.seriesNames = []
            this.$nextTick(() => {
              zymedia('.video_video', {
                aspectRation: this.momday_video.width / this.momday_video.height,
                preload: 'auto',
                autoplay: true,
                enableVisibilityState: false,
                nativeControls: true,
                alwaysShowNativeControls: false,
                success(data) {
                  // console.log(data)
                }
              })
              zymedia('.video_banner', {
                aspectRation: '353' / '280',
                videoWidth: '353px',
                videoHeight: '280px',
                preload: 'auto',
                autoLoop: true,
                autoplay: true,
                hideVideoControlsOnLoad: true,
                enableFullscreen: false,
                enableVisibilityState: false,
                success(data) {
                  // console.log(data)
                }
              })
            })
          })
          this.salseranknavlist = res.data.tagslist
          this.bannerbackcolor = this.bannerlist.length ? this.bannerlist[0].color : ''
          this.categoryFn()
          this.defaultSearch = res.data.default_search ? res.data.default_search : ''
          if (this.defaultSearch) this.$store.commit('DEFAULT_SEARCH', this.defaultSearch)
          // this.skinShow = true
          this.ord_popup_ads = res.data.popup_ads
          this.birthday_pop = res.data.birthday_popup_ads
          this.prepay_popup = res.data.prepay_popup
          if (typeof fn == 'function') fn()
          window.addEventListener('scroll', this.scrollToTop)
        }
      })
    },
    momdayPlay(type) {
      if (type == 'init' && !this.momday_play_init) {
        return
      }
      try {
        if (type == 'init') {
          document.getElementsByClassName('video_video')[0].play()
          this.momday_play_init = 0
        } else {
          if (this.momday_isplay == 0) {
            document.getElementsByClassName('video_video')[0].pause()
            this.momday_isplay = 1
          } else {
            document.getElementsByClassName('video_video')[0].play()
            this.momday_isplay = 0
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 首页普通弹窗
    ordPopFn: function () {
      // that.currentPopType => 当前接口返回的是那种弹框类型 0-普通弹框 1-vip礼包弹框
      // 如果是普通弹框，每天弹1次
      // console.log('日常活动弹框')

      console.log(new Date().getHours(), new Date().getMinutes())
      let curTime = new Date().getTime(),
        type = 'ordPop'

      if (this.ord_popup_ads.dateConfig) {
        this.ord_popup_ads.dateConfig.map((item) => {
          let time0 = new Date(item.date[0].replace(/-/g, '/')).getTime(),
            time1 = new Date(item.date[1].replace(/-/g, '/')).getTime()
          if (time0 < curTime && curTime <= time1) {
            if (!localStorage.getItem(type + time0)) {
              clearPopCache(type)
              localStorage.setItem(type + time0, 1)
            }
            this.popType(item.times, this.ord_popup_ads, type) // 设为100 原意为 需求：不限制次数
          } else {
            localStorage.removeItem(type + time0)
          }
        })
      } else {
        this.popType(3, this.ord_popup_ads, type) // 设为100 原意为 需求：不限制次数
      }
      if (!this.is_pop) {
        this.specialPop()
        // this.getOrderCoupon()
      }
    },
    popType: function (popNum, popup_ads, type, callback, timetype) {
      var that = this
      popType(
        popNum,
        popup_ads,
        type,
        callback,
        function () {
          that.is_pop = true
          that.popup_ads = popup_ads
        },
        function () {
          if (that.noticmsg) {
            that.$toast(that.noticmsg)
          }
        },
        timetype
      )
      that.goXcxCreateBtnFn()
    },
    doSort(index, list) {
      // console.log(index)
      if (index < list.length) {
        if (this.nowPage == 1 && (index == 0 || index == 1)) {
          if (index == 0) {
            this.salseranklist1 = [list[index]]
          } else if (index == 1) {
            this.salseranklist2 = [list[index]]
          }
        } else {
          if (this.$refs.listItem1.clientHeight <= this.$refs.listItem2.clientHeight) {
            this.salseranklist1.push(list[index])
          } else {
            this.salseranklist2.push(list[index])
          }
        }
        if (index < list.length - 1) {
          this.loading = true
        } else {
          this.tabDisabled = false
          this.loading = false
        }
        let that = this
        this.$nextTick(() => {
          setTimeout(() => {
            that.doSort(index + 1, list)
          }, 100)
        })
      } else {
        // scrollTo(0, this.$refs.list.offsetTop - 55)
      }
    },
    onInfinite: function () {
      if (!this.salseranknavlist.length) return
      this.tagid = this.salseranknavlist[this.salserank].tagid
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getGuessData()
    },
    salserankClick(name) {
      console.log(this.salserank)
      if (this.salserank1 == name) return
      this.$clickburiedPoint({
        data: {
          buttonCode: 'itemclass-' + (this.salserank + 1)
        }
      })
      this.salserank1 = this.salserank = name
      this.tagid = this.salseranknavlist[this.salserank].tagid
      this.nowPage = 0
      this.salseranklist1 = []
      this.salseranklist2 = []
      this.salseranklist = []
      this.onInfinite()
    },
    getGuessData() {
      this.tabDisabled = true
      let url =
          this.$ajax.getRecommend_URL +
          '?pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize +
          '&tagid=' +
          this.tagid,
        that = this
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          if (this.nowPage == 1) {
            this.salseranklist1 = []
            this.salseranklist2 = []
            this.salseranklist = res.data.itemlist
            this.refresh = false
          } else {
            this.salseranklist = this.salseranklist.concat(res.data.itemlist)
          }
          if (res.data.itemlist.length < this.pagesize) {
            this.finished = true
            if (this.nowPage == 1 && !res.data.itemlist.length) {
              this.salseranklist1 = []
              this.salseranklist2 = []
            }
          } else {
            this.finished = false
          }
          if (res.data.itemlist.length <= 0) {
            that.tabDisabled = false
          } else {
            that.$nextTick(() => {
              setTimeout(() => {
                that.doSort(0, res.data.itemlist)
              }, 100)
            })
          }
        }
      })
    },
    goDetail: function (item, index, flowArea, name) {
      this.$clickburiedPoint({
        data: {
          buttonCode: flowArea
        },
        callback: () => {
          this.$clickburiedPoint({
            url: 'ckysdatacenter/itemclick/save',
            data: {
              itemid: item.item_id,
              scenepoint: 'MAIN',
              scenedesc: name
            }
          })
          this.$router.push({
            path: 'productdetail',
            query: {
              itemid: item.item_id
            }
          })
        }
      })
    },
    bannerClick: function (items, index, flowArea) {
      bannerClick(items, index, flowArea, this, () => {
        this.dataCollection(items, index, flowArea)
      })
    },
    goSignin: function () {
      this.$router.push({
        path: '/integral'
      })
    },
    // 跳转消息中心
    goMessage: function () {
      // 登录校验
      if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
        this.$router.push({
          path: '/login',
          query: {
            routeval: ''
          }
        })
      } else {
        this.$router.push('/messagecenter')
      }
    },
    // 跳转搜索
    searchClick: function () {
      this.$router.push('/search')
    },
    groupQr: function () {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'ToChat'
        }
      })
      setTimeout(function () {
        window.location = '/static/wx/html/groupqrcode.html'
      }, 100)
    },
    stick: function () {
      var that = this
      setTimeout(function () {
        that.jump(document.querySelectorAll('.stick'))
      })
    },
    goSkinTest() {
      // 皮肤测试
      if (this.skinInfo.orderid) {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'skin'
          },
          callback: () => {
            this.$router.push({
              path: '/analysisDetail',
              query: {
                orderid: this.skinInfo.orderid,
                sex: this.skinInfo.sex,
                source: 'records'
              }
            })
          }
        })
      } else {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'skin'
          },
          callback: () => {
            this.$router.push('/skinAnalysis')
          }
        })
      }
    },
    // goLiveList: function () {
    //   this.$clickburiedPoint({
    //     data: {
    //       buttonCode: 'ToLive'
    //     }
    //   })
    //   if (isWeixin()) {
    //   } else {
    //     this.$toast("请前往微信搜索小程序「创客云商可丽金官方」");
    //   }
    // },
    // 点击滚动
    jump: function (dom) {
      var jump = dom
      var total = jump[0].offsetTop - 54
      var distance =
        parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      if (total > distance) {
        smoothDown()
      } else {
        smoothUp()
      }
      function smoothDown() {
        var step = total / 10
        if (distance < total) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothDown, 30)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
      function smoothUp() {
        var newTotal = distance - total
        var step = newTotal / 5
        if (distance > 0) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothUp, 30)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
    },
    // 客服
    keFu: function () {
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: ''
            }
          })
        } else {
          this.$clickburiedPoint({
            data: {
              buttonCode: 'ToSer'
            }
          })
          setTimeout(function () {
            kefu()
          }, 100)
        }
      } else {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'ToSer'
          }
        })
        setTimeout(function () {
          kefu()
        }, 100)
      }
    },
    goXcxCreateBtnFn: function () {
      var that = this
      setTimeout(function () {
        goXcxCreateBtnFn(that, 'index')
      }, 500)
    },
    categoryFn() {
      let aliVal = parseInt(this.categorylist.length / 10),
        remainder = this.categorylist.length % 10,
        cardnum = 5,
        itemnum = 10,
        indextemp1 = 0,
        indextemp2 = 0
      // 整除排列
      for (let i = 0; i < aliVal; i++) {
        for (let j = 0; j < cardnum; j++) {
          let index1 = i * itemnum + j,
            index2 = i * itemnum + j + cardnum
          this.categorylist[index1].index = index1
          this.categorylist[index2].index = index2
          this.categorylisttd.push([this.categorylist[index1], this.categorylist[index2]])
          indextemp1 = index1
          indextemp2 = index2
        }
      }
      // 余数补位
      for (let i = 0; i < cardnum; i++) {
        let index1 = indextemp1 + (i + 1) + cardnum,
          index2 = indextemp2 + (i + 1) + cardnum
        if (indextemp1 == 0 && indextemp2 == 0) {
          index1 = i
          index2 = i + cardnum
        }
        if (this.categorylist[index1] && this.categorylist[index2]) {
          this.categorylist[index1].index = index1
          this.categorylist[index2].index = index2
          this.categorylisttd.push([this.categorylist[index1], this.categorylist[index2]])
        } else if (this.categorylist[index1]) {
          this.categorylist[index1].index = index1
          this.categorylisttd.push([this.categorylist[index1]])
        } else {
          break
        }
      }
    },
    videogoodsIndexFn: function (index, tagsindex) {
      if (this.videogoodslist[index].type == 2) {
        this.videogoodslist[index].videoIndex = tagsindex
        this.$refs.videoSwiper[index].swiper.slideToLoop(tagsindex, 500, false) //切换到第一个slide，速度为1秒
      } else {
        this.$refs.videoSwiper[index].swipeTo(tagsindex, { immediate: false })
      }
    },
    videogoodschange(goodsIndex, index) {
      // console.log(goodsIndex, index)
      try {
        this.videogoodslist[index].videoIndex = goodsIndex
        var len = this.videogoodslist[index].goodsList.length,
          prevDom,
          nextDom,
          dom
        dom = this.$refs['video_banner-' + index + '-' + goodsIndex][0]
        if (this.videogoodslist[index].videoIndex == 0) {
          prevDom = this.$refs['video_banner-' + index + '-' + (len - 1)][0]
          nextDom =
            this.$refs[
              'video_banner-' + index + '-' + (this.videogoodslist[index].videoIndex + 1)
            ][0]
        } else if (this.videogoodslist[index].videoIndex == len - 1) {
          prevDom =
            this.$refs[
              'video_banner-' + index + '-' + (this.videogoodslist[index].videoIndex - 1)
            ][0]
          nextDom = this.$refs['video_banner-' + index + '-0'][0]
        } else {
          prevDom =
            this.$refs[
              'video_banner-' + index + '-' + (this.videogoodslist[index].videoIndex - 1)
            ][0]
          nextDom =
            this.$refs[
              'video_banner-' + index + '-' + (this.videogoodslist[index].videoIndex + 1)
            ][0]
        }
        if (
          dom.localName != 'img' &&
          this.videogoodslist[index].goodsList[goodsIndex].is_play == 0
        ) {
          dom.play()
        }
        if (prevDom.localName != 'img') prevDom.pause()
        if (nextDom.localName != 'img') nextDom.pause()
      } catch (e) {}
    },
    videoClick(index, goodsIndex) {
      this.videogoodslist[index].goodsList[goodsIndex].is_play = 0
      // console.log(this.videogoodslist)
      // this.is_play = 0
      // console.log(this.$refs['video_banner-' + index + '-' + goodsIndex]);
      this.$refs['video_banner-' + index + '-' + goodsIndex][0].play()
    },
    loadstart(e) {},
    scrollTopHeader(scroll) {
      scroll.scrollTop = scroll.scrollTop - (this.newPeopleHeight || 0)
      if (Number(scroll.scrollTop) >= 0) {
        this.currscroll = scroll.scrollTop
        this.stickShow = document.documentElement.clientHeight <= this.currscroll ? 1 : 0
        let scrollheight = 102
        if (
          scrollheight / 4 < scroll.scrollTop &&
          scrollheight / 2 >= scroll.scrollTop &&
          this.currscroll >= this.lastscroll &&
          this.lastscroll != 0
        ) {
          this.isheaderwidth = 1
          this.isheadertop = 0
        } else if (scrollheight / 2 < scroll.scrollTop) {
          this.isheaderwidth = 1
          this.isheadertop = 1
        } else if (
          scrollheight / 4 < scroll.scrollTop &&
          scrollheight / 2 >= scroll.scrollTop &&
          this.currscroll < this.lastscroll
        ) {
          this.isheadertop = 0
          this.isheaderwidth = 1
        } else if (scrollheight / 4 >= scroll.scrollTop) {
          this.isheadertop = 0
          this.isheaderwidth = 0
        }
        this.lastscroll = scroll.scrollTop
        if (!this.onlyone && this.stickShow) {
          this.onlyone = 1
          if (this.salseranknavlist.length) {
            this.tagid = this.salseranknavlist[this.salserank].tagid
            this.getGuessData()
          } else {
            this.loading = false
            this.finished = true
          }
        }
      }
    },
    scrollTopSalserank(scroll) {
      this.isFixedSalserank = scroll.isFixed
    },
    scrollToTop() {
      // 获取视窗高度
      var domHight = document.body.offsetHeight,
        scrollTop =
          window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
        id,
        scrollHeight,
        offsetTop,
        top,
        bottom
      id = this.$refs.videogoods
      if (!id) return
      id.map((item, index) => {
        scrollHeight = item.scrollHeight
        offsetTop = item.offsetTop
        top = offsetTop - domHight > 0 ? offsetTop - domHight : 0
        bottom = scrollHeight + offsetTop
        // console.log('-------'+index+'-------', scrollTop, top, bottom, id[0].offsetTop, id[1].offsetTop, this.videogoodslist[0].goodsTransform, this.videogoodslist[1].goodsTransform)
        // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
        if (scrollTop >= top && scrollTop <= bottom) {
          if (
            !this.videogoodslist[index].goodsTransform &&
            scrollTop >= top + 480 &&
            scrollTop <= bottom - 200
          ) {
            this.videogoodslist[index].goodsTransform = true
          }
          try {
            let dom =
              this.$refs['video_banner-' + index + '-' + this.videogoodslist[index].videoIndex][0]
            // console.log('元素出现在可视区: ', dom.localName, index, this.videogoodslist[index].videoIndex, dom.paused)
            if (dom.localName != 'img' && dom.paused) {
              this.videogoodslist[index].goodsList[
                this.videogoodslist[index].videoIndex
              ].is_play = 1
              // if (this.videogoodslist[index].goodsList[this.videogoodslist[index].videoIndex].is_play != 1) {
              //   dom.play()
              //   this.videogoodslist[index].videoplay = 1
              // }
            }
          } catch (e) {}
        } else {
          if (this.videogoodslist[index].goodsTransform) {
            this.videogoodslist[index].goodsTransform = false
          }
          try {
            let dom =
              this.$refs['video_banner-' + index + '-' + this.videogoodslist[index].videoIndex][0]
            // console.log('元素不在了: ', dom.localName, index, this.videogoodslist[index].videoIndex, dom.paused)
            if (dom.localName != 'img') {
              dom.pause()
              this.videogoodslist[index].goodsList[
                this.videogoodslist[index].videoIndex
              ].is_play = 1
              this.videogoodslist[index].videoplay = 0
            }
          } catch (e) {}
        }
      })
    },
    dataCollection(items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },
    goldRainFun() {
      clearTimeout(this.goldRainSetTimeout)
      this.showcoupon0426 = false
      window.location.href =
        this.goldRainData.pop_target + '?' + 'goldencoinmoney=' + this.goldRainData.goldencoinmoney
    },
    receive: function (type) {
      var url = this.$ajax.addCoupon_URL
      var data = {
        couponsendid: this.couponsendid,
        type: type
      }
      var that = this
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          if (type == 0) {
            that.showcouponget = false
            if (that.info.ispop == 1) {
              if (that.info.randomtype == 0) {
                that.showcoupon5 = true
              } else if (that.info.randomtype == 1) {
                that.showcoupon10 = true
              }
            }
          }
        }
      })
    },
    receive1: function () {
      this.$router.push('/classification')
    },
    goCoupon: function () {
      this.showcoupon5 = false
      this.showcoupon10 = false
      this.showcouponget = false
      this.$router.push('/classification')
    },
    goAct: function (flowArea, type) {
      if (type == 'redPacket') {
        window.location.href = 'static/wx/html/couponlist.html?type=happybuycoupon'
      } else if (type == 'subscribepopup') {
        window.location.href = this.subscribe_pop.pop_ad_target
      } else if (type == 'pop50popup') {
        window.location.href = this.pop50_ad_target
      } else if (type == 'yearlivepop') {
        this.yearlivepop.ispop = 0
        window.location.href = this.yearlivepop.popads.pop_ad_target
      } else {
        this.is_pop = false
        this.bannerClick(this.popup_ads, 0, flowArea)
      }
    },
    // 跳转至优惠券列表页
    goCouponList() {
      this.closeCoupon()
      this.$router.push('/cashcoupon')
    },
    // 跳转至分类页
    goShopping() {
      this.closeCoupon()
      this.$router.push('/classification')
    },
    // 关闭产品券弹窗
    closeCoupon() {
      this.showCoupon = !this.showCoupon
    },
    closeAct: function () {
      this.is_pop50 = false
      this.is_pop = false
      this.showAct = false
      this.redPacketShow = 0
      this.subscribe_pop.ispop = 0
      this.yearlivepop.ispop = 0
      this.momdayPlay('init')
    }
  }
}
</script>

<style scoped lang="scss">
.new-people-wrap {
  width: 100%;
  position: relative;
  img {
    width: 100%;
    height: auto;
  }
  .code-img {
    width: 18%;
    position: absolute;
    top: 12.5%;
    left: 59.8%;
  }
}
.index {
  /*padding-bottom: 0.57rem;*/
  .header {
    padding: 0 0 0.04rem;
    /*height: 1.02rem;*/
    transition: all 0.2s;
    background: #fea9ae;
    position: relative;
    z-index: 99;
    &.headerheight {
      /*height: 0.44rem !important;*/
      /*overflow: hidden;*/
    }
    .headsearch {
      width: 100%;
      top: 0;
      transition: all 0.2s;
      padding: 0 0.11rem;
      &.headsearchwidth {
        width: 70%;
      }
      &.headsearchtop {
        top: -0.33rem;
      }
    }
  }
  .header_content,
  .header_content .icon,
  .hot,
  .hot li {
    display: flex;
  }
  .header_content {
    justify-content: space-between;
  }
  .header_content,
  .hot,
  .hot li {
    align-items: center;
  }
  .header_content {
    padding: 0.08rem 0.11rem 0.08rem;
    background: #fea9ae;
    span {
      color: #ffffff;
      font-size: 0.14rem;
      opacity: 1;
      transition: all 0.2s;
      &.opac {
        opacity: 0;
      }
    }
    .icon {
      img {
        width: 0.24rem;
        height: 0.24rem;
        margin-left: 0.12rem;
      }
    }
  }
  .headsearch .inp {
    margin-right: 0;
  }
  .hot {
    margin-top: 0.04rem;
    flex-wrap: wrap;
    opacity: 1;
    transition: all 0.2s;
    padding: 0 0.11rem;
    &.opac {
      margin-top: -2rem;
      opacity: 0;
    }
    li {
      margin-left: 0.1rem;
      color: #ffffff;
      font-size: 0.1rem;
      img {
        width: 0.09rem;
        height: 0.09rem;
        margin-right: 0.03rem;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .banner {
    margin-top: -0.01rem;
    position: relative;
    /*min-height: 1.92rem;*/
    border-radius: 0 0 100% 100%;
    transition: all 0.5s;
    height: 1.03rem;
    /*margin-bottom: 0.1rem;*/
    .back {
      width: 100%;
      height: 0.64rem;
      padding-top: 0.1rem;
      border-radius: 0 0 100% 100%;
      opacity: 1;
      transition: all 0.2s ease;
      background: #fea9ae;
      &.backshow {
        opacity: 0;
      }
    }
    .swiper-wrapper {
      .swiper-slide {
        overflow: hidden;
        border-radius: 0.1rem;
        height: 0.97rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    ul {
      padding: 0.51rem 0.1rem 0;
      box-sizing: border-box;
      li {
        overflow: hidden;
        border-radius: 0.04rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .category {
    background: #ffffff;
    margin: 0.1rem 0.11rem 0;
    border-radius: 0.1rem;
    padding: 0.11rem 0;
    #categoryBanner {
      .item {
        text-align: center;
        margin-top: 0.12rem;
        &:first-child {
          margin-top: 0;
        }
        img {
          width: 0.36rem;
          height: 0.36rem;
          color: #333333;
          margin: 0 auto 0.06rem;
          /*border-radius: 0.16rem;*/
        }
      }
    }
  }
  .countdown {
    margin: 0.1rem 0.11rem;
    position: relative;
    img {
      width: 100%;
    }
    .van-count-down {
      padding-left: 13%;
      padding-right: 15%;
      position: absolute;
      bottom: 13%;
      width: 100%;
    }
    .time {
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.12rem;
      .colon {
        display: block;
        width: 0.45rem;
        height: 0.44rem;
        /*background: url(/static/images/block.png?v=1) no-repeat center;*/
        background-size: 100%;
        text-align: center;
        line-height: 0.44rem;
        color: #d64556;
        font-size: 0.28rem;
        margin-right: 0.02rem;
      }
    }
  }
  .click_play {
    z-index: 100;
    display: inline-block;
    position: absolute;
    left: 0.1rem;
    top: 0.18rem;
    .circle {
      width: 0.3rem;
      height: 0.3rem;
      background: transparent;
      border-radius: 50%;
      position: relative;
      .circleCh1 {
        width: 0.2rem;
        height: 0.2rem;
        text-align: center;
        font-size: 0;
        animation: myfirst 1s infinite;
      }
      .circleCh {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border: 0.01rem solid #ffffff;
        background: rgba(255, 255, 255, 0.35);
      }

      @keyframes myfirst {
        0% {
          transform: scale(1);
        }
        35% {
          transform: scale(1.1);
        }
        50% {
          transform: scale(1.5);
        }
        75% {
          transform: scale(1.1);
        }
        100% {
          transform: scale(1);
        }
      }
    }
  }
  .activity {
    margin: 0.1rem 0 0;
    padding-bottom: 0.1rem;
    position: relative;
    #activitySwiperPagination {
      width: 100%;
      bottom: 0;
    }
  }
  .featuredads {
    margin: 0.1rem 0.11rem 0;
    border-radius: 0.1rem;
    overflow: hidden;
    &.mall_endorsement {
      border-radius: 0;
    }
    img {
      width: 100%;
    }
    .video_box {
      img {
        position: absolute;
        right: 0.1rem;
        top: 0.15rem;
        z-index: 1;
        width: 0.2rem;
        height: 0.2rem;
        &.momday_videoplay {
          top: 0.45rem;
        }
      }
    }
  }
  .skinText {
    margin: 0.1rem 0 0;
  }
  .videogoods {
    position: relative;
    margin: 0.1rem 0.11rem 0;
    .title {
      height: 0.37rem;
      width: 100%;
      margin: 0 auto;
      margin-bottom: 0.08rem;
    }
    .video {
      border-radius: 0.1rem;
    }
    video {
      width: 100%;
      object-fit: cover;
    }
    .image {
      width: 100%;
      height: 2.81rem;
      position: absolute;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .goods {
      width: 100%;
      position: relative;
      z-index: 2;
      .goodsimg {
        width: 100%;
        height: 4.23rem;
      }
    }
    .goods1 {
      width: 100%;
      height: 1.38rem;
      position: relative;
      top: -1.38rem;
      z-index: 1;
      transition: all 2s;
      padding: 0 0.13rem;
      img {
        width: 100%;
        height: 100%;
      }
      &.goods1_transform {
        top: 0;
      }
    }
    .videogoods_tags {
      /*background: #ffffff;*/
      /*border: 0.005rem solid #ccc;*/
      /*border-radius: 0.15rem;*/
      height: 0.28rem;
      margin: 0 0.31rem 0.12rem;
      div {
        text-align: center;
        white-space: nowrap;
        line-height: 0.27rem;
        width: 0.96rem;
        /*border: 0.005rem solid transparent;*/
        /*border-radius: 0.14rem;*/
        color: #333;
        height: 100%;
        background-size: 100% 100% !important;
      }
    }
    .bgimg {
      padding-top: 0.16rem;
    }
    .activity {
      margin: 0.16rem 0 0;
      padding-bottom: 0;
      .image {
        height: 3.86rem;
      }
      .baseimg {
        margin-top: -0.84rem;
        position: relative;
        z-index: 2;
      }
    }
  }
  .series {
    margin-top: 0.1rem;
    .title {
      img {
        height: 0.95rem;
        border-radius: 0.12rem;
      }
    }
    img {
      width: 100%;
    }
  }
  .salserank {
    position: relative;
    z-index: 99;
    background: #f5f5f5;
    .salseranknav {
      text-align: center;
      p {
        color: #333333;
      }
      span {
        color: #999999;
        border-radius: 0.1rem;
        display: inline-block;
        padding: 0.01rem 0.05rem;
        margin-top: 0.01rem;
      }
    }
    .list {
      width: 100%;
      padding-right: 0.1rem;
      overflow: hidden;
      margin-top: 0;
      transition: all 0.4s;
      .listItem {
        padding-left: 0.1rem; // 剧中
        width: 50%;
        float: left;
      }
    }
  }
  #bannerSwiperPagination,
  #activitySwiperPagination,
  #videogoodsSwiperPagination,
  .seriesSwiperPagination {
    width: auto;
    /*background: url(../../assets/images/pagebg.png) no-repeat left top;*/
    /*background-size: 100% 100%;*/
    font-size: 0;
    color: #ffffff;
    /*right: 0.21rem;*/
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    /*padding: 0 0.0385rem 0.01rem;*/
  }
  #videogoodsSwiperPagination {
    bottom: 0;
  }
  .floatBtn {
    position: fixed;
    right: 0.17rem;
    bottom: 0.79rem;
    background: transparent;
    z-index: 2001;
    .imgLive {
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    img,
    .imgLive {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      &:first-of-type {
        margin-bottom: 0.04rem;
      }
    }
  }
  .floatadvert {
    position: fixed;
    left: 0.17rem;
    top: 60%;
    z-index: 2001;
    overflow: hidden;
    img {
      width: 0.7rem;
    }
  }

  /*弹窗*/
  .pop-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .content-wrap {
      z-index: 10001;
      box-sizing: border-box;
      width: 2.72rem;
      height: 2.75rem;
      background: #fff;
      border-radius: 0.12rem;
      text-align: center;
      line-height: 0.32rem;
      .logo {
        display: block;
        margin: 0.2rem auto 0.15rem;
        width: 0.8rem;
        height: 0.8rem;
      }
      .name {
        color: #c9ab6d;
        font-size: 0.23rem;
        font-weight: bold;
      }
      .label {
        color: #fc0324;
        font-size: 0.15rem;
        margin: 0.1rem 0.27rem 0.18rem;
        line-height: 0.21rem;
      }
      .footer-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.23rem;
        div {
          width: 1.04rem;
          height: 0.31rem;
          line-height: 0.31rem;
          box-sizing: border-box;
          text-align: center;
          font-size: 0.12rem;
          border-radius: 0.16rem;
          &.btn-see {
            color: #fc0324;
            border: 0.01rem solid #fc0324;
          }
          &.btn-buy {
            color: #fff;
            background: #fc0324;
          }
        }
      }
    }
  }
  .block {
    &.positionblock {
      .img {
        position: relative;
        p {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0.75rem;
          font-size: 0.11rem;
          color: #f8f7f7;
          text-align: center;
        }
      }
    }
    .couponget {
      width: 60%;
      margin: 0 auto;
    }
  }
  // 金币雨专用
  .block1 {
    width: 100%;
    background-color: transparent;
    text-align: center;
    font-size: 0;
    position: static;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .van-icon-close {
    margin-top: 0.4rem;
    font-size: 30px;
    color: #fff;
  }
  .sharecontainer {
    position: fixed;
    width: 100%;
    z-index: 100;
    height: 100%;
    left: 0;
    top: 0;
  }
  .sharecontainer img {
    position: absolute;
    top: 0.2rem;
    right: 0.73rem;
    width: 1.53rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .sharecontainer .know {
    width: 1.09rem;
    height: 0.36rem;
    line-height: 0.36rem;
    color: #fff;
    border-color: #fff;
    background: transparent;
    position: absolute;
    bottom: 1.5rem;
    left: 50%;
    margin-left: -0.54rem;
  }
  .couponpopup .img {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    width: 80%;
  }
  .couponpopup .close {
    // left: auto !important;
    right: 5%;
    top: 63%;
    color: #ffffff;
    // opacity: 0.4;
  }
  .couponpopup .close.close1 {
    // top: 15%;
  }
  .couponpopup img {
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    width: 97%;
  }
  .couponpopup .img img {
    position: initial;
    width: 100%;
    transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
  }
  .couponpopup .couponget {
    width: 60%;
  }
  .couponpopup .couponget.couponget1 {
    width: 80%;
  }
  .couponpopup .know {
    width: auto;
    height: auto;
    left: 50%;
    margin-left: -0.15rem;
  }
  .couponpopup p {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0.75rem;
    font-size: 0.11rem;
    color: #f8f7f7;
    text-align: center;
  }
}
</style>
<style lang="scss">
.index {
  .banner {
    .swiper-container {
      margin: 0;
      position: absolute;
      top: 0.06rem;
      width: 100%;
      .swiper-wrapper {
        padding: 0 0.1rem;
        box-sizing: border-box;
      }
    }
    #bannerSwiperPagination {
      bottom: 0.1rem;
      span {
        margin-left: 0.05rem;
        &.swiper-pagination-bullet {
          width: 0.05rem;
          height: 0.05rem;
          border-radius: 50%;
          background: #ffffff;
          opacity: 1;
        }
        &:first-child {
          margin-left: 0;
        }
        &.swiper-pagination-bullet-active {
          background: #fc0324;
        }
      }
    }
  }
  .activity {
    /*height: 2.16rem;*/
    width: 100%;
    overflow: hidden;
    .swiper-container {
      width: 128%;
      margin-left: -14%;
    }

    .swiper-slide .main-img {
      width: 100%;
      height: 2.7rem;
      margin: 0 auto;
      display: block;
      border-radius: 0.08rem;
      transition: all 0.3s;
    }
    .swiper-slide {
      transform: scale(0.9);
      transition: all 0.2s ease-in 0s;
      border-top-left-radius: 0.07rem;
      border-top-right-radius: 0.07rem;
    }
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1);
      border-top-left-radius: 0.04rem;
      border-top-right-radius: 0.04rem;
    }
  }
  .videogoods {
    > .swiper-container {
      /*background: #FAEAEA;*/
      border-radius: 0.1rem;
      .zy_controls,
      .dec_loading,
      .dec_error,
      .dec_play {
        display: none;
      }
    }
    .activity {
      .swiper-slide {
        transform: scale(0.8);
        transition: all 0.2s ease-in 0s;
        border-top-left-radius: 0.07rem;
        border-top-right-radius: 0.07rem;
      }
      .swiper-slide-active,
      .swiper-slide-duplicate-active {
        transform: scale(1);
        border-top-left-radius: 0.04rem;
        border-top-right-radius: 0.04rem;
      }
    }
  }
  .series {
    .van-cell {
      background: transparent;
      padding: 0 0.11rem 0.1rem;
      .van-cell__right-icon {
        display: none;
      }
    }
    .van-collapse-item__content {
      background: transparent;
      padding: 0 0.11rem 0.26rem;
    }
    .seriesgoods {
      position: relative;
    }
    .seriesSwiperPagination {
      /*bottom: -0.1rem;*/
    }
  }
  .salserank {
    &.salserankheight {
      min-height: 6.67rem;
    }
    &.salserankBack {
      .van-sticky--fixed {
        /*bottom: 0;*/
        /*padding-bottom: 0.5rem;*/
        z-index: 2000;
        /*overflow: hidden;*/
      }
      .van-tabs__nav {
        background: #ffffff;
        /*padding-top: 0.06rem;*/
      }
      .list {
        padding-top: 0.1rem;
        overflow: auto;
        height: 92%;
      }
    }
    .van-tabs--line .van-tabs__wrap {
      height: 0.58rem;
      padding-bottom: 0.14rem;
    }
    .van-tabs__nav {
      background: #f5f5f5;
      padding: 0.06rem 0 0.12rem;
      .van-tab {
        .salseranknav {
          p {
            font-weight: bold;
          }
        }
      }
      .van-tab--active {
        .salseranknav {
          p {
            color: #fc0324;
          }
          span {
            color: #fc0324;
            background: #f5dce0;
          }
        }
      }
      .van-tabs__line {
        display: none;
      }
      > div:nth-last-of-type(2) {
        padding-right: 0.11rem;
      }
    }
    .van-tab {
      padding: 0 0.14rem;
      &:first-of-type {
        padding-left: 0.11rem;
      }
    }
  }
  .slide_cl_xcx {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
  }
  #activitySwiperPagination,
  #videogoodsSwiperPagination,
  .seriesSwiperPagination {
    span {
      &.swiper-pagination-bullet {
        width: 0.11rem;
        height: 0.02rem;
        border-radius: 0.01rem;
        margin: 0 !important;
        background: #cccccc;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
  #bannerSwiperPagination,
  #activitySwiperPagination,
  #videogoodsSwiperPagination,
  .seriesSwiperPagination {
    text-align: center;
    span {
      margin-left: 0.05rem;
      background: rgba(0, 0, 0, 0.2);
      &.swiper-pagination-bullet-active {
        background: #fc0324;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/homePage.vue